<template>
	<section class="main-content">
		<div class="row">
			<slot>
				<div class="columns column12 align-center">
					<h1>{{ title }}</h1>
					<h1>{{ subtitle }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.main-content {
	overflow: hidden;
	background: var(--primary-background-color);

	:deep(p) {
		font-size: 18px;
		line-height: 34px;
	}
}

@media (max-width: 1480px) {
	:deep(p) {
		font-size: 16px !important;
		line-height: 30px;
	}
}

@media (max-width: 880px) {
	.main-content {
		padding: 40px 0;

		:deep(p) {
			line-height: 28px;
		}
	}

	.intro {
		padding: 50px 0;
	}
}
</style>
